import { fetchReports } from "../api/documents";
import { STATIC_REPORTS } from "../content/staticDocuments";
import { byDateDesc } from "../utils/sortByDate";
import useApiResource from "./useApiResource";

/**
 * Отчёты из API вместе с зашитыми в код, от новых к старым.
 *
 * Общий источник для страницы «Отчеты» и блока на главной — иначе «последние
 * отчёты» на главной и первые записи в списке могли бы разойтись.
 *
 * @param {{ limit?: number }} options `limit` — сколько записей вернуть.
 */
export function useReports({ limit } = {}) {
  const { data, loading, error } = useApiResource(
    (signal) => fetchReports({ signal }),
    [],
    { initialData: [] },
  );

  const reports = [...data, ...STATIC_REPORTS].sort(byDateDesc);

  return {
    reports: limit ? reports.slice(0, limit) : reports,
    loading,
    error,
  };
}

export default useReports;
